import { ChangeDetectionStrategy, Component } from '@angular/core';
import { environment } from 'src/libs/angular/core/src/lib/environments/environment';

@Component({
  selector: 'aa-services-section',
  standalone: true,
  imports: [],
  templateUrl: './services-section.component.html',
  styleUrl: './services-section.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ServicesSectionComponent {
  customerAppURLBase = environment.customerAppURL;
}
